import { render, staticRenderFns } from "./DocumentDetailsProcessing.vue?vue&type=template&id=91b30af2&"
import script from "./DocumentDetailsProcessing.vue?vue&type=script&lang=js&"
export * from "./DocumentDetailsProcessing.vue?vue&type=script&lang=js&"
import style0 from "./DocumentDetailsProcessing.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports